import { PALETTE } from '../../../constants';

export default {
  block: {
    backgroundColor: PALETTE.primaryActive,
    borderRadius: 2,
  },
  inline: {
    color: PALETTE.primaryActive,
  },
  transparent : {
    color: PALETTE.secondaryText,
  },

  text: {
    textAlign: 'center',
  },
  xsmall: {
  },
  small: {
    padding: 2,
  },
  normal: {
    padding: 4,
  },
  large: {
    padding: 6,
  },
  header1: {
    padding: 16,
  },
  header2: {
    padding: 12,
  },
  header3: {
    padding: 8,
  },
  header4: {
    padding: 6,
  },
};
